export default __webpack_public_path__ + "static/media/Anna Mucea.be75bb0e.png";